import { useMemo } from 'react';
import type { TGroupShape } from '@alfa-bank/site-select-v2/src/models/common';

import type { TOption, TValueKey } from '../models/common';
import type { TValidationRules } from '../models/validation';
import { getInitialValue, isOptionWithId } from '../utils';
import { getValidateStatus } from '../utils/validation';

import { valueKeyVariants } from './config';

type TUseFormSelect = {
    initialValueIndex?: number;
    multiple?: boolean;
    options: Array<TOption | TGroupShape>;
    validationRules?: TValidationRules;
    valueKey: TValueKey;
};

export const useFormSelect = ({
    initialValueIndex,
    multiple,
    options,
    validationRules,
    valueKey,
}: TUseFormSelect) => {
    const formatedOptions = useMemo(
        () =>
            options.map(option => {
                if (isOptionWithId(option)) {
                    return { ...option, key: option.id, content: option.label };
                }

                return option;
            }),
        [options]
    );

    const initialValue = useMemo(
        () => getInitialValue(formatedOptions, initialValueIndex),
        [formatedOptions, initialValueIndex]
    );

    const validate = useMemo(
        () => getValidateStatus(validationRules, multiple),
        [multiple, validationRules]
    );

    return {
        formatedOptions,
        initialValue,
        currentValueKey: valueKeyVariants[valueKey],
        validate,
    };
};
